module.exports = __webpack_public_path__ + "img/102.2fd4fff6.jpg";